var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-button",
    transform: "translate(0.498 0.501)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "translate(-0.498 -0.501)",
    fill: "#e21b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M184.408,156.444,170.9,142.936l-20.652,21.412,13.371,13.371A24.294,24.294,0,0,0,184.408,156.444Z",
    transform: "translate(-136.195 -129.577)",
    fill: "#c40606"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5878",
    "data-name": "Group 5878",
    transform: "translate(13.132 12.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M160.834,159.894a1.893,1.893,0,0,1-1.342-.556L141.1,140.948a1.9,1.9,0,1,1,2.683-2.683l18.391,18.391a1.9,1.9,0,0,1-1.342,3.239Z",
    transform: "translate(-140.545 -137.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    d: "M142.436,159.892a1.9,1.9,0,0,1-1.342-3.239l18.391-18.391a1.9,1.9,0,1,1,2.683,2.683l-18.39,18.391A1.892,1.892,0,0,1,142.436,159.892Z",
    transform: "translate(-140.538 -137.706)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXButton);
export default __webpack_public_path__ + "static/media/x-button.5c1dcb2849aa5cc1105f7758b7e9835c.svg";
export { ForwardRef as ReactComponent };